module.exports = __webpack_public_path__ + "static/media/package_develop_mobile_app.3c4a66d7.svg";